import { Helmet } from 'react-helmet-async'
import HomeTemplate from '../templates/HomeTemplate.jsx'
import DownloaderSEO from '../components/ui/DownloaderSEO.jsx'
import { PAGES, buildFAQSchema, buildHowToSchema } from '../utils/seo.js'
import { useLanguage } from '../context/LanguageContext.jsx'

const { title, description, canonical } = PAGES.facebook

const faqSchema = buildFAQSchema([
  { q: 'Can I download Facebook videos as both MP3 and MP4?', a: 'Yes! FastAudio downloads Facebook videos as MP3 audio (up to 320kbps) or MP4 video (SD 480p or HD 720p). Both options appear after you paste the URL.' },
  { q: 'What types of Facebook videos can I download?', a: 'Public Facebook video posts, Watch videos, and Reels. Private videos and login-restricted content cannot be downloaded.' },
  { q: 'How do I get the correct Facebook video URL?', a: 'Click ⋯ on the post → Copy link. On mobile, tap Share → Copy link.' },
  { q: 'Can I download Facebook Reels as MP4?', a: 'Yes! Publicly accessible Facebook Reels can be downloaded as MP4 video or MP3 audio.' },
  { q: 'Can I download private Facebook videos?', a: 'No — only publicly visible content without a Facebook login can be downloaded.' },
])

const howToSchema = buildHowToSchema('How to Download Facebook Videos as MP3 or MP4', [
  { title: 'Find the Facebook video', text: 'Open the video post on Facebook.' },
  { title: 'Copy the URL', text: 'Click ⋯ on the post → Copy link.' },
  { title: 'Paste into FastAudio', text: 'Paste the URL — the video info loads automatically.' },
  { title: 'Choose your format', text: 'Pick MP3 audio or MP4 video (SD/HD) from the quality table.' },
  { title: 'Click Download', text: 'Hit ⚡ Download and save your file.' },
])

export default function FacebookDownloader() {
  const { t } = useLanguage()
  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(howToSchema)}</script>
      </Helmet>
      <HomeTemplate
        provider="facebook"
        title={title}
        description={description}
        canonical={canonical}
        badge={t('facebookBadge')}
        heading={
          <>
            {t('facebookH1')}{' '}
            <span className="text-gradient">{t('facebookH2')}</span>
          </>
        }
        subheading={t('facebookSub')}
        placeholder={t('fbPlaceholder')}
      >
        <DownloaderSEO provider="facebook" />
      </HomeTemplate>
    </>
  )
}
